<!--
  Inline discounted-price pair: struck original next to the re-priced figure,
  with optional trailing wording ("your first quarter"). Renders the plain
  amount + note when no discount applies, so callers use it unconditionally.
  Amounts are dollars; formatCurrency drops a trailing .00. Reused by the
  limited-time-offer bar.
-->
<template>
  <span>
    <template v-if="hasDiscount">
      <span class="text-neutral-400 line-through">{{ formatCurrency(original) }}</span>
      {{ ' ' }}
      <span class="font-semibold text-secondary-700">{{ formatCurrency(discounted!) }}{{ note ? ` ${note}` : '' }}</span>
    </template>
    <template v-else>{{ formatCurrency(original) }}{{ note ? ` ${note}` : '' }}</template>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatCurrency } from '@/shared/utils/formatCurrency.js'

const props = defineProps<{
  original: number
  discounted?: number | null
  note?: string
}>()

const hasDiscount = computed(() => props.discounted != null && props.discounted < props.original)
</script>
